// Native slideshow remains the single source of selection, including swipes and zoom.
class PebbleCarouselThumbnails extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.gallery = this.closest('media-gallery');
    this.slideshow = this.gallery?.querySelector(':scope > slideshow-component');
    this.track = this.querySelector('.pebble-carousel-thumbnails__track');
    this.buttons = [...this.querySelectorAll('[data-index]')];
    if (!this.slideshow || !this.track) return;
    this.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.dataset.index !== undefined) {
        // Rapid thumbnail selection must not enter Horizon's animated reorder path:
        // it locks selection while waiting for scrolling and drops subsequent clicks.
        // Instant selection also avoids leaving temporary slides between real media.
        this.slideshow.select(Number(button.dataset.index), event, { animate: false });
      } else if (button.dataset.direction) {
        this.track.scrollBy({ left: Number(button.dataset.direction) * this.track.clientWidth * .8, behavior: 'instant' });
      }
    }, { signal });
    // A small mouse movement between rapid clicks must not start native image drag.
    this.addEventListener('dragstart', event => event.preventDefault(), { signal });
    this.gallery.addEventListener('slideshow:select', event => {
      if (event.target === this.slideshow) this.sync(event.detail.index);
    }, { signal });
    this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive: true });
    this.observer = new ResizeObserver(() => this.updateArrows());
    this.observer.observe(this.track);
    customElements.whenDefined('slideshow-component').then(() => {
      if (this.isConnected && !signal.aborted) this.sync(this.slideshow.current || 0);
    });
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
  sync(index) {
    this.buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
    const button = this.buttons[index];
    if (!button) return;
    // Only scroll the thumbnail rail: scrollIntoView would also jump the product page.
    const rect = button.getBoundingClientRect();
    const viewport = this.track.getBoundingClientRect();
    if (rect.left < viewport.left + 4) this.track.scrollLeft += rect.left - viewport.left - 4;
    else if (rect.right > viewport.right - 4) this.track.scrollLeft += rect.right - viewport.right + 4;
    this.updateArrows();
  }
  updateArrows() {
    this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft <= 1;
    this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
  }
}
if (!customElements.get('pebble-carousel-thumbnails')) customElements.define('pebble-carousel-thumbnails', PebbleCarouselThumbnails);
